import type { FC } from 'react';
import React, { createContext, useMemo } from 'react';

import { useIsReactionsEnabled } from '@confluence/comments-hooks/entry-points/useIsReactionsEnabled';

export type ReactionsContextValue = {
	isReactionsEnabled: boolean;
};

export const ReactionsContext = createContext<ReactionsContextValue>({
	isReactionsEnabled: false,
});
ReactionsContext.displayName = 'ReactionsContext';

type ReactionsProviderProps = {
	contentId: string;
	children?: React.ReactNode;
};

export const ReactionsProvider: FC<ReactionsProviderProps> = ({ contentId, children }) => {
	const isReactionsEnabled = useIsReactionsEnabled(contentId);

	const reactionsContextValue = useMemo(() => ({ isReactionsEnabled }), [isReactionsEnabled]);

	return (
		<ReactionsContext.Provider value={reactionsContextValue}>{children}</ReactionsContext.Provider>
	);
};
